var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import * as React from 'react';
import withPaddingAndMargin from '../withPaddingAndMargin';

var Row = function Row(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ['className']);

  var classNames = ['dd-row', className].filter(function (x) {
    return x;
  }).join(' ');
  return React.createElement('section', _extends({
    className: classNames
  }, otherProps));
};

export default withPaddingAndMargin(Row);